import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type AddOnModalStore } from 'pages/settings/ui/AddOnModal/store/addOnModalStore'

type IModalSecondStepActionsProps = {
  store: AddOnModalStore
}

export const ModalSecondStepActions = observer(({ store }: IModalSecondStepActionsProps) => {
  return (
    <>
      <Button
        text='Back'
        onClick={store.returnToFirstStep}
        typeBtn={'contained'}
        size={'medium'}
        contained={'secondary'}
      />
      <Button
        text='Activate'
        onClick={store.secondStepAction}
        loading={store.loading}
        disabled={store.loading}
      />
    </>
  )
})
